import React, { useEffect, useState } from 'react'
import { capitalize } from '../../utils/helpers'
import Switch from '../Switch'
import Separator from '../Separator'

interface CookieModalFieldProps {
  text: string
  id: string
  isLast: boolean
  cookieForm: Record<string, { on: boolean; editable: boolean }>
  setCookieForm: (form: Record<string, { on: boolean; editable: boolean }>) => void
}

const CookieModalField = ({
    text,
    isLast,
    id,
    cookieForm,
    setCookieForm,
}: CookieModalFieldProps) => {
    const [isOn, setIsOn] = useState(cookieForm[id].on)

    useEffect(() => {
        const newForm = {
            ...cookieForm,
        }
        newForm[id] = {
            ...cookieForm[id],
            on: isOn,
        }
        setCookieForm(newForm)
    }, [isOn])
    return (
        <div>
            <div className='flex justify-between'>
                <div className='max-w-[592px]'>
                    <div className='flex justify-between items-center pb-2'>
                        <h5 className='cookies-header'>Enable {capitalize(id)} Cookies</h5>
                        <div className='md:hidden'>
                            <Switch
                                isOn={isOn}
                                toggle={() => setIsOn(!isOn)}
                                disabled={!cookieForm[id].editable}
                            />
                        </div>
                    </div>
                    <p className='cookies-text'>{text}</p>
                </div>
                <div className='hidden md:block'>
                    <Switch isOn={isOn} toggle={() => setIsOn(!isOn)} disabled={!cookieForm[id].editable} />
                </div>
            </div>
            {isLast || <Separator className='my-6' />}
        </div>
    )
}

export default CookieModalField
